import { render, staticRenderFns } from "./UserInfoSubSection.vue?vue&type=template&id=2a7e1e4e&scoped=true"
import script from "./UserInfoSubSection.vue?vue&type=script&lang=js"
export * from "./UserInfoSubSection.vue?vue&type=script&lang=js"
import style0 from "./UserInfoSubSection.vue?vue&type=style&index=0&id=2a7e1e4e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7e1e4e",
  null
  
)

export default component.exports